import loadable from 'react-loadable';
import i18n from '@signavio/i18n';
import { createLoadingMessage } from '@signavio/effektif-commons';
const Services = loadable({
  loader: () => import(/* webpackChunkName: "services-and-connectors" */'./Main'),
  loading: createLoadingMessage(() => ({
    loading: i18n('Preparing services and connectors...')
  }))
});
export default Services;